// JobBoardViewAccordion.tsx - CORREGIDO para el acordeón funcional

import React, { useState } from 'react';
import { FaBriefcase, FaChevronDown, FaChevronUp, FaMapMarkerAlt, FaSpinner } from 'react-icons/fa';
import { VacantePublica, VacanteDetalle } from './types';
import { JobBoardViewDetail } from './JobBoardViewDetail';
import { jobBoardViewService } from './services/jobBoardViewService';
import './styles.css';

interface JobBoardViewAccordionProps {
  vacantes: VacanteDetalle[]; // Solo resúmenes desde window
  tipo: 'activas' | 'inactivas';
  onPostular: (vacante: VacantePublica) => void;
}

export const JobBoardViewAccordion: React.FC<JobBoardViewAccordionProps> = ({
  vacantes,
  tipo,
  onPostular
}) => {
  const [openVacante, setOpenVacante] = useState<string | null>(null);
  const [vacanteCompleta, setVacanteCompleta] = useState<VacantePublica | null>(null);
  const [loadingDetalle, setLoadingDetalle] = useState(false);
  const [errorDetalle, setErrorDetalle] = useState<string | null>(null);

  const toggleVacante = async (jobBoardId: string) => {
    if (openVacante === jobBoardId) {
      setOpenVacante(null);
      setVacanteCompleta(null);
      setErrorDetalle(null);
      return;
    }

    setOpenVacante(jobBoardId);
    setLoadingDetalle(true);
    setErrorDetalle(null);
    setVacanteCompleta(null);

    try {
       const detallesCompletos = await jobBoardViewService.getVacanteCompleta(jobBoardId);
      setVacanteCompleta(detallesCompletos);
    } catch (err: any) {
      console.error('Error al cargar detalles de la vacante:', err);
      setErrorDetalle(err.message || 'Error al cargar los detalles');
    } finally {
      setLoadingDetalle(false);
    }
  };

  if (vacantes.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-state-content">
          <h5>
            {tipo === 'activas'
              ? 'No hay vacantes disponibles'
              : 'No hay registros disponibles'
            }
          </h5>
          <p>
            {tipo === 'activas'
              ? 'Actualmente no tenemos posiciones abiertas. Te invitamos a consultar próximamente.'
              : 'No se han registrado procesos de selección finalizados.'
            }
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="accordion-list">
      {vacantes.map((vacanteResumen) => (
        <article
          key={vacanteResumen.job_board_id}
          className={`accordion-article ${openVacante === vacanteResumen.job_board_id ? 'open' : ''}`}
        >
          <button
            className={`accordion-header ${openVacante === vacanteResumen.job_board_id ? 'water-active' : ''}`}
            onClick={() => toggleVacante(vacanteResumen.job_board_id)}
            type="button"
            disabled={loadingDetalle && openVacante === vacanteResumen.job_board_id}
          >
            <div className="vacante-header-content">
              <div className="vacante-title-section">
                <h4 className="vacante-main-title">{vacanteResumen.denominacion_funcional}</h4>
                <p className="vacante-subtitle">{vacanteResumen.denominacion_tabular || 'Información adicional disponible'}</p>
                <div className="vacante-meta">
                  <FaBriefcase className="meta-icon" />
                  <span>Folio: {vacanteResumen.folio_vacante}</span>
                  
                  {tipo === 'activas' && (
                    <>
                      <span className="meta-separator">|</span>
                      <span className="vacante-status">Activa</span>
                    </>
                  )}
                </div>
              </div>
              
              <div className="vacante-header-actions">
                {tipo === 'activas' && (
                  <span className="vacante-status-badge active">{vacanteResumen.status_name}</span>
                )}
                {tipo === 'inactivas' && (
                  <span className="vacante-status-badge inactive">{vacanteResumen.status_name}</span>
                )}
                
                {/* Mostrar spinner cuando está cargando */}
                {loadingDetalle && openVacante === vacanteResumen.job_board_id ? (
                  <FaSpinner className="loading-spinner" />
                ) : (
                  <span className={`accordion-chevron ${openVacante === vacanteResumen.job_board_id ? 'rotate' : ''}`}>
                    {openVacante === vacanteResumen.job_board_id ? <FaChevronUp /> : <FaChevronDown />}
                  </span>
                )}
              </div>
            </div>
          </button>
          <div className={`accordion-body ${openVacante === vacanteResumen.job_board_id ? 'open' : ''}`}>
            <div className="accordion-detail">
              {loadingDetalle && (
                <div className="loading-detail-state">
                  <FaSpinner className="loading-spinner large" />
                  <span>Cargando detalles completos...</span>
                </div>
              )}

              {errorDetalle && (
                <div className="error-detail-state">
                  <div className="error-message">
                    <h5>Error al cargar detalles</h5>
                    <p>{errorDetalle}</p>
                    <button
                      onClick={() => toggleVacante(vacanteResumen.job_board_id)}
                      className="retry-btn"
                    >
                      Reintentar
                    </button>
                  </div>
                </div>
              )}

              {vacanteCompleta && !loadingDetalle && !errorDetalle && (
                <JobBoardViewDetail
                  vacante={vacanteCompleta}
                  tipo={tipo}  
                  onPostular={() => onPostular(vacanteCompleta)}
                />
              )}
            </div>
          </div>
        </article>
      ))}
    </div>
  );
};